import React, { useState, useRef, useEffect } from "react";
import "./index.css";
import "rc-tree/assets/index.css";
import Tree, { TreeNode } from "rc-tree";
import CheckboxChecked from "Assets/Icons/CheckboxChecked";
import CheckboxOutline from "Assets/Icons/CheckboxOutline";
import CheckboxDisabled from "Assets/Icons/CheckboxDisabled";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import PlusCloseIcon from "Assets/Icons/PlusCloseIcon";
import MinusCloseIcon from "Assets/Icons/MinusCloseIcon";
import styled from "styled-components";
import { getAllNodes } from "utilFunctions/helperFunctions/utilFunctions";
import NotMarkedNew from "Assets/Icons/NotMarkedIconNew";
import TickIcon from "Assets/Icons/TickIcon";
import { Tag, Tooltip } from "antd";
import InfoIcon from "Assets/Icons/InfoIcon";
const NodeTitleSpan = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "14px"};
`;
const StyledTag = styled<any>(Tag)`
  height: fit-content !important;
`;
const MultinodePicker = (props: any) => {
  const {
    nodes,
    allCoveredTopics,
    handleSelectedNodesToBeAdded,
    checkedKeysList,
    handleCheckedNodes,
    handleOnlyAllCheckedNodes,
    fullTree,
    popOver,
    handleRemoveUnCheckKey,
    mode,
    chapterNodeDetail,
    lecturePrecheckedNodes,
    courseNodePL,
    isPlannedMode,
    isMarkedAsRevision,
    isRevisionChapterSelected,
  } = props;
  const treeRef = useRef(null);
  const { screen }: any = useWindowSize();
  const [checked, setChecked] = useState<any>([]);
  const checkedBKUP = checkedKeysList ? checkedKeysList : [];
  const disabledTopic =
    lecturePrecheckedNodes && lecturePrecheckedNodes.length
      ? lecturePrecheckedNodes
      : [];
  const [expendkey, setExpendKey] = useState<any>(
    getAllNodes(nodes).map((ele: any) => String(ele.key))
  );
  const [state, setState] = useState({
    defaultExpandedKeys: checkedKeysList,
    defaultSelectedKeys: checkedKeysList,
    defaultCheckedKeys: checkedKeysList,
  });

  useEffect(() => {
    if (nodes.length) {
      setExpendKey(getAllNodes(nodes).map((ele: any) => String(ele.key)));
    }
  }, [nodes]);
  useEffect(() => {
    setState({
      ...state,
      defaultCheckedKeys: checkedKeysList,
      defaultSelectedKeys: checkedKeysList,
      defaultExpandedKeys: checkedKeysList,
    });
  }, [checkedKeysList]);
  const onSelect = (selectedKeys: any, info: any) => {
    if (
      !state.defaultSelectedKeys.includes(info?.node?.key) &&
      !info?.node?.selected
    ) {
      if (
        info?.node &&
        info?.node?.children &&
        Array.isArray(info?.node?.children) &&
        info?.node?.children.length > 0
      ) {
        setExpendKey([...expendkey, ...selectedKeys]);
        setState({
          ...state,
          defaultSelectedKeys: [...state.defaultSelectedKeys, ...selectedKeys],
        });
      } else {
        setState({
          ...state,
          defaultSelectedKeys: [...state.defaultSelectedKeys, ...selectedKeys],
          defaultCheckedKeys: [...state.defaultCheckedKeys, ...selectedKeys],
        });
        const newKey = [info?.node.key];
        setChecked((prevstate: any) => [...prevstate, ...newKey]);
        handleCheckedNodes([...state.defaultCheckedKeys, ...selectedKeys]);
      }
    } else {
      if (
        info?.node &&
        info?.node?.children &&
        Array.isArray(info?.node?.children) &&
        info?.node?.children.length > 0
      ) {
        const filteredExpend = expendkey.filter(
          (item: any) => item != info?.node?.key
        );
        setExpendKey([...filteredExpend]);
        setState({
          ...state,
          defaultSelectedKeys: [...state.defaultSelectedKeys, ...selectedKeys],
        });
      } else {
        const filteredDefaultChecked = state.defaultCheckedKeys.filter(
          (item: any) => item != info?.node?.key
        );
        const filteredSelected = state.defaultSelectedKeys.filter(
          (item: any) => item != info?.node?.key
        );
        const filteredCheck = checked.filter(
          (item: any) => item != info?.node?.key
        );
        const filterAllcovered = allCoveredTopics.filter(
          (item: any) => item != info?.node?.key
        );
        setChecked([...filteredCheck]);
        setState({
          ...state,
          defaultSelectedKeys: [...filteredSelected],
          defaultCheckedKeys: [...filteredDefaultChecked],
        });
        handleRemoveUnCheckKey(info?.node.key);
        // handleOnlyCheckedNodes([...filteredDefaultChecked]);
        handleOnlyAllCheckedNodes([...filterAllcovered]);
      }
    }
  };

  const setTreeRef = (tree: any) => {
    treeRef.current = tree;
  };

  const getNodeType = (nodes: any, pos: any) => {
    const position = pos.split("-");
    return position.length > 4
      ? nodes[position[1]]?.children[position[2]]?.children[position[3]]
          ?.children[position[4]]
      : position.length > 3
      ? nodes[position[1]]?.children[position[2]]?.children[position[3]]
      : position.length > 2
      ? nodes[position[1]]?.children[position[2]]
      : nodes[position[1]];
  };
  const getChapter = (nodes: any, pos: any) => {
    const position = pos.split("-");
    return position.length > 0 ? nodes[position[1]] : {};
  };
  const onCheck = (checkedKeys: any, info: any) => {
    if (!checkedBKUP.includes(String(info?.node?.key)) && fullTree) {
      const checkedNodeType = getNodeType(nodes, info?.node?.pos);
      const chapterNode = getChapter(nodes, info?.node?.pos);
      const newchapterNode = { ...chapterNode };
      delete newchapterNode.children;
      const newObj = [
        { ...info?.node, nodeType: checkedNodeType.nodeType },
        // { ...newchapterNode },
      ];
      // const position = info?.node?.pos.split("-");
      // if (position.length > 2) {
      //   const topicNode =
      //     position.length > 2 ? nodes[position[1]]?.children[position[2]] : {};
      //   const newtopicNode = { ...topicNode };
      //   delete newtopicNode.children;
      //   newObj.push(newtopicNode);
      // }
      handleSelectedNodesToBeAdded([...newObj]);
      const newKey = [info?.node.key];
      setChecked((prevstate: any) => [...prevstate, ...newKey]);
      const newKeys = [...checked, ...newKey];
      handleCheckedNodes([...newKeys]);
    } else if (!fullTree) {
      handleCheckedNodes([...checkedKeys]);
    } else {
      handleRemoveUnCheckKey(info?.node.key);
    }
    const checkekeys = [...checkedKeys];
    // setChecked(checkekeys);
    setState({
      ...state,
      defaultCheckedKeys: checkekeys,
    });
  };
  const isDisabled = (key: any) => {
    let retVal = false;

    const extraNodes = checkedBKUP.filter((el: any) => {
      if (isMarkedAsRevision) {
        return !disabledTopic.includes(el);
      } else {
        return !disabledTopic.includes(parseInt(el));
      }
    });
    if (
      extraNodes &&
      extraNodes.length &&
      extraNodes.includes(String(key)) &&
      !checked.includes(String(key))
    ) {
      retVal = true;
    } else {
      retVal = false;
    }

    return retVal;
    // console.log(retVal);
    // return false;
  };

  const isDisabledNode = (item: any) => {
    let value = false;
    if (item.enabled != undefined) {
      value = item.enabled ? false : true;
    } else {
      value = false;
    }
    return value;
  };

  const checkIsExpandedPrescribed = (item: any, prescribed: any) => {
    if (prescribed.includes(String(item.key))) {
      return true;
    } else return false;
  };
  const showRevisionDetail = (item: any) => {
    if (!isDisabled(item.key)) {
      return (
        <Tooltip
          title={() => (
            <div className="d-flex gap-2 pl-2">
              If your syllabus is complete or there are no new topics to mark
              for syllabus compliance, please mark this lecture as a revision
              lecture
            </div>
          )}
        >
          <InfoIcon
            id={"Tooltip-attendance1"}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          ></InfoIcon>
        </Tooltip>
      );
    }
    return null;
  };
  const showFacultyDetail = (item: any) => {
    const nodeItem = chapterNodeDetail.find(
      (ele: any) => ele.nodeId === item.key
    );
    const facultyDetail = item.facultyName ? item : nodeItem ? nodeItem : null;
    if (facultyDetail) {
      return (
        <Tooltip
          title={() => (
            <div className="d-flex gap-2 pl-2">
              {"(" + facultyDetail?.lectureName + ", "}
              {facultyDetail?.updatedAt &&
                convertTime(facultyDetail?.updatedAt, "D MMM") + ", "}
              {" " + facultyDetail?.facultyName + ")"}
            </div>
          )}
        >
          <InfoIcon
            id={"Tooltip-attendance1"}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          ></InfoIcon>
        </Tooltip>
      );
    }
    return null;
  };
  const showNodePL = (item: any, index: any, courseNodePLids: any) => {
    if (item && item != null && Object.keys(courseNodePLids).length) {
      return (
        courseNodePLids[item.key] && (
          <Tooltip
            title={() => (
              <>
                This topic is assigned to planned lecture{" "}
                {courseNodePLids[item.key]} in Phoenix for this particular
                batch.
              </>
            )}
          >
            <StyledTag>PL-{courseNodePLids[item.key]}</StyledTag>
          </Tooltip>
        )
      );
    }
    return null;
  };
  const nodeTitleWithTag = (item: any, index: number) => {
    return (
      <div
        className={
          ["xs", "sm", "md"].includes(screen)
            ? "chapterViewStyle d-flex flex-col"
            : "chapterViewStyle d-flex flex-row"
        }
      >
        <div className="nodeTitleStyle">{item.title || item.nodeTitle}</div>
        <div className="d-flex pl-2">
          {["myScheduleHome"].includes(mode) && !isPlannedMode
            ? showNodePL(item, index, courseNodePL)
            : null}
          {["mybatchSyllabus", "myScheduleHome"].includes(mode)
            ? isRevisionChapterSelected
              ? showRevisionDetail(item)
              : showFacultyDetail(item)
            : null}
        </div>
      </div>
    );
  };
  const loop = (data: any) =>
    data.map((item: any, index: number) => {
      if (item.children && item.children.length) {
        return (
          <TreeNode
            icon={(props) => {
              if (
                props.data?.children ||
                (props.disableCheckbox && !fullTree)
              ) {
                return;
              } else {
                if (props.disableCheckbox) {
                  return (
                    <div
                      className={
                        item.nodeType == "Sub-Topic" && fullTree
                          ? "checkboxplacementSubtopicDisable"
                          : "checkboxplacementSubtopicDisable"
                      }
                    >
                      {" "}
                      {isPlannedMode && ["myScheduleHome"].includes(mode) ? (
                        <TickIcon size={18} />
                      ) : (
                        <CheckboxDisabled />
                      )}
                    </div>
                  );
                } else if (props.checked) {
                  return (
                    <div
                      className={
                        item.nodeType == "Sub-Topic" && fullTree
                          ? "checkboxplacementSubtopic"
                          : "checkboxplacementSubtopic"
                      }
                    >
                      {isPlannedMode && ["myScheduleHome"].includes(mode) ? (
                        <TickIcon size={18} />
                      ) : (
                        <CheckboxChecked />
                      )}
                    </div>
                  );
                }
                return (
                  <div
                    className={
                      item.nodeType == "Sub-Topic" && fullTree
                        ? "checkboxplacementSubtopic"
                        : "checkboxplacementSubtopic"
                    }
                  >
                    {["mybatchSyllabus"].includes(mode) ||
                    (["myScheduleHome"].includes(mode) && isPlannedMode) ? (
                      <NotMarkedNew size={18} />
                    ) : (
                      <CheckboxOutline />
                    )}
                  </div>
                );
              }
            }}
            disabled={fullTree ? isDisabled(item.key) : false}
            disableCheckbox={
              popOver
                ? true
                : fullTree
                ? isDisabled(item.key)
                : isDisabledNode(item)
            }
            checkable={true}
            key={item.key || item.nodeId}
            title={
              <NodeTitleSpan
                screen={screen}
                className={
                  checkIsExpandedPrescribed(item, expendkey)
                    ? "prescribedlectureTitle2"
                    : "parentNodeTitle2"
                }
              >
                {nodeTitleWithTag(item, index)}
              </NodeTitleSpan>
            }
          >
            {loop(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          icon={(props) => {
            if (props.data?.children || (props.disableCheckbox && !fullTree)) {
              return;
            } else {
              if (props.disableCheckbox) {
                return (
                  <div
                    className={
                      item.nodeType == "Sub-Topic" && fullTree
                        ? "checkboxplacementSubtopicDisable"
                        : "checkboxplacementSubtopicDisable"
                    }
                  >
                    {" "}
                    {isPlannedMode && ["myScheduleHome"].includes(mode) ? (
                      <TickIcon size={18} />
                    ) : (
                      <CheckboxDisabled />
                    )}
                  </div>
                );
              } else if (checkedKeysList.includes(String(item.key))) {
                return (
                  <div
                    className={
                      item.nodeType == "Sub-Topic" && fullTree
                        ? "checkboxplacementSubtopic"
                        : "checkboxplacementSubtopic"
                    }
                  >
                    {isPlannedMode && ["myScheduleHome"].includes(mode) ? (
                      <TickIcon size={18} />
                    ) : (
                      <CheckboxChecked />
                    )}
                  </div>
                );
              }
              return (
                <div
                  className={
                    item.nodeType == "Sub-Topic" && fullTree
                      ? "checkboxplacementSubtopic"
                      : "checkboxplacementSubtopic"
                  }
                >
                  {["mybatchSyllabus", "mybatchTestSyllabus"].includes(mode) ||
                  (["myScheduleHome"].includes(mode) && isPlannedMode) ? (
                    <NotMarkedNew size={18} />
                  ) : (
                    <CheckboxOutline />
                  )}
                </div>
              );
            }
          }}
          checkable={true}
          disabled={
            isPlannedMode && ["myScheduleHome"].includes(mode)
              ? true
              : ["mybatchSyllabus", "mybatchTestSyllabus"].includes(mode)
              ? true
              : fullTree
              ? isDisabled(item.key)
              : false
          }
          disableCheckbox={
            popOver
              ? true
              : fullTree
              ? isDisabled(item.key)
              : isDisabledNode(item)
          }
          key={item.key || item.nodeId}
          title={
            <NodeTitleSpan
              screen={screen}
              className={
                checkIsExpandedPrescribed(item, expendkey)
                  ? "prescribedlectureTitle"
                  : "parentNodeTitle"
              }
            >
              {nodeTitleWithTag(item, index)}
            </NodeTitleSpan>
          }
        />
      );
    });
  const onExpand = (expandedKeys: any) => {
    setExpendKey(expandedKeys);
  };
  const switcherIcon = (obj: any) => {
    if (obj.isLeaf) {
      return null;
    } else {
      if (obj?.expanded) {
        return <MinusCloseIcon />;
      } else {
        return <PlusCloseIcon />;
      }
    }
  };
  return (
    <Tree
      ref={setTreeRef}
      autoExpandParent={true}
      className={!fullTree ? "rc-tree-height" : ""}
      showLine={false}
      checkable={isPlannedMode ? false : true}
      onExpand={onExpand}
      onSelect={onSelect}
      onCheck={onCheck}
      expandedKeys={expendkey}
      defaultSelectedKeys={state.defaultSelectedKeys}
      checkedKeys={state.defaultCheckedKeys}
      showIcon={true}
      onActiveChange={(key: any) =>
        console.log("checkIsExpandedPrescribed:", key)
      }
      switcherIcon={switcherIcon}
    >
      {loop(nodes)}
    </Tree>
  );
};
export default MultinodePicker;
